import clsx from 'clsx'
import {FC} from 'react'
import {useAuthUser} from 'react-auth-kit'
import {useIntl} from 'react-intl'
import {toAbsoluteUrl} from '../../../helpers'
import {HeaderUserMenu} from '../../../partials'

const itemClass = 'ms-1 ms-lg-3'
const Topbar: FC = () => {
  const intl = useIntl()
  const authUser = useAuthUser()
  const userAvatarClass = 'symbol-35px'

  return (
    <div className='d-flex align-items-stretch flex-shrink-0'>
      <div className='d-flex align-items-center'>
        <span className='d-none d-md-inline me-1'>{intl.formatMessage({id: 'HI'})},</span>
        <span className='d-none d-md-inline fw-bolder'>{authUser()?.fullName}</span>
      </div>
      <div className={clsx('app-navbar-item', itemClass)}>
        <div
          className={clsx('cursor-pointer symbol symbol-badge', userAvatarClass)}
          data-kt-menu-trigger="{default: 'click'}"
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
        >
          <img src={toAbsoluteUrl('/media/avatars/300-3.jpg')} alt='' />
        </div>
        <HeaderUserMenu />
      </div>
    </div>
  )
}

export {Topbar}
